export default "__VITE_ASSET__CvAI9xBJ__"